'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Common;
(function (Common) {
    var MyCommon = /** @class */ (function () {
        function MyCommon() {
            var _this = this;
            this.anchor = {
                elm: {},
                href: '',
                disabled: false,
            };
            var self = this;
            // リンクボタン挙動
            $('a').click(function (e) {
                if ($(e.target).prop("tagName").toLowerCase() == 'a') {
                    _this.setAnchor($(e.target));
                }
                else {
                    _this.setAnchor($(e.target).parent());
                }
                if (_this.anchor.disabled) {
                    return false;
                }
                else {
                    return _this.smoothScroll();
                }
            });
            // 擬似リンクボタン
            if ($('.trigFakeAnchor').length > 0) {
                $('.trigFakeAnchor').click(function () {
                    var href = $(this).data("href");
                    if (href) {
                        location.href = href;
                    }
                });
            }
            $('.trigOpenCloseNavi').click(function () {
                if ($('.trigOpenCloseNavi').attr("data-open") == '1') {
                    $('.trigOpenCloseNavi').attr("data-open", 0);
                    _this.closeNavi();
                }
                else {
                    $('.trigOpenCloseNavi').attr("data-open", 1);
                    _this.openNavi();
                }
            });
            $('.trigCloseNavi').click(function () {
                $('.trigOpenCloseNavi').attr("data-open", 0);
                _this.closeNavi();
            });
            $('.trigOpenCloseShows').click(function () {
                var id = $(this).data("id");
                console.log(id);
                if ($(this).attr("data-open") == '0') {
                    $(this).attr("data-open", 1);
                    self.changeToOpenTrigStr(id);
                    self.openShows(id);
                }
                else {
                    $(this).attr("data-open", 0);
                    self.changeToCloseTrigStr(id);
                    self.closeShows(id);
                }
            });
            if ($('body.home').length > 0) {
                if ($(window).width() > 767) {
                    $(window).scroll(function () {
                        var sc = $(window).scrollTop();
                        $('.trigPararax02').css({ top: (sc / 4) });
                        $('.trigPararax03').css({ top: -(sc * 3) });
                    });
                }
            }
        }
        MyCommon.prototype.setAnchor = function (el) {
            this.anchor.elm = el;
            this.anchor.href = el.attr("href");
            this.anchor.disabled = el.attr("disabled") == "disabled";
        };
        MyCommon.prototype.smoothScroll = function () {
            if (this.anchor.href != '#') {
                if (this.anchor.href.match(/^#/)) {
                    var target = $(this.anchor.href == "#" || this.anchor.href == "" ? 'html' : this.anchor.href);
                    var position = target.offset().top;
                    if (this.anchor.elm.attr("data-no-anime") == "1") {
                        var speed = 0;
                        $("html, body").animate({ scrollTop: position }, speed, "linear");
                    }
                    else {
                        var speed = 500;
                        $("html, body").animate({ scrollTop: position }, speed, "swing");
                    }
                    //console.log("smoothScroll");
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        };
        MyCommon.prototype.closeNavi = function () {
            $('.bulletNavi').fadeOut();
        };
        MyCommon.prototype.openNavi = function () {
            $('.bulletNavi').fadeIn();
        };
        MyCommon.prototype.closeShows = function (id) {
            $('.bulletShows[data-id="' + id + '"]').slideDown();
        };
        MyCommon.prototype.openShows = function (id) {
            $('.bulletShows[data-id="' + id + '"]').slideUp();
        };
        MyCommon.prototype.changeToCloseTrigStr = function (id) {
            $('.trigOpenCloseShows[data-id="' + id + '"]').html('Close <i class="fa fa-close"></i>').blur();
        };
        MyCommon.prototype.changeToOpenTrigStr = function (id) {
            $('.trigOpenCloseShows[data-id="' + id + '"]').html('More info').blur();
        };
        return MyCommon;
    }());
    Common.MyCommon = MyCommon;
})(Common || (Common = {}));
exports.default = Common;
